/* FIT RECON v4 — Being Gurkha
   Body-based size recommendation + 3D body preview (desktop/tablet). No dependencies. */
(function () {
  'use strict';

  var STORE_PREFIX = 'bgFitRecon:v3:';
  try { localStorage.removeItem('bgFitRecon:v2'); } catch (e) {} // retire guest profiles from v2
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ *
   * Garment data (from the Being Gurkha size charts)
   * units: cm unless noted. tee/hoodie chest = half chest (pit to pit).
   * ------------------------------------------------------------------ */
  var CHARTS = {
    tshirt: [
      { size: 'XXS', chestHalf: 54.4, frontLength: 72, shoulder: 20.3 }, { size: 'XS', chestHalf: 55.75, frontLength: 72.5, shoulder: 20.3 },
      { size: 'S', chestHalf: 57, frontLength: 73, shoulder: 20.3 }, { size: 'M', chestHalf: 59.5, frontLength: 74, shoulder: 20.6 },
      { size: 'L', chestHalf: 62.5, frontLength: 75.5, shoulder: 21 }, { size: 'XL', chestHalf: 65.5, frontLength: 76.5, shoulder: 21.4 },
      { size: 'XXL', chestHalf: 68.5, frontLength: 78.5, shoulder: 21.8 }
    ],
    hoodie: [
      { size: 'XXS', chestHalf: 58, frontLength: 70.5, shoulder: 18 }, { size: 'XS', chestHalf: 59.25, frontLength: 71, shoulder: 18.45 },
      { size: 'S', chestHalf: 60.5, frontLength: 71.5, shoulder: 18.9 }, { size: 'M', chestHalf: 63, frontLength: 72.5, shoulder: 19.8 },
      { size: 'L', chestHalf: 66, frontLength: 74, shoulder: 21 }, { size: 'XL', chestHalf: 69, frontLength: 75.5, shoulder: 22.2 },
      { size: 'XXL', chestHalf: 72, frontLength: 77, shoulder: 23.4 }
    ],
    jacket: [
      { size: 'XS', chest: 104.2, backLength: 65, sleeveLength: 67 }, { size: 'S', chest: 109.2, backLength: 66, sleeveLength: 68 },
      { size: 'M', chest: 114.2, backLength: 67, sleeveLength: 69 }, { size: 'L', chest: 119.2, backLength: 68, sleeveLength: 70 },
      { size: 'XL', chest: 124.2, backLength: 69, sleeveLength: 71 }, { size: 'XXL', chest: 129.2, backLength: 70, sleeveLength: 72 }
    ],
    puffer: [
      { size: 'XXS', chest: 113, hem: 107, sleeveLength: 66, backLength: 68 }, { size: 'XS', chest: 118, hem: 112, sleeveLength: 67, backLength: 69 },
      { size: 'S', chest: 123, hem: 117, sleeveLength: 68, backLength: 70 }, { size: 'M', chest: 128, hem: 122, sleeveLength: 69, backLength: 71 },
      { size: 'L', chest: 133, hem: 127, sleeveLength: 70, backLength: 71 }, { size: 'XL', chest: 138, hem: 132, sleeveLength: 71, backLength: 73 },
      { size: 'XXL', chest: 143, hem: 138, sleeveLength: 72, backLength: 74 }
    ],
    shorts: [ /* inches */
      { size: 'XS', waistIn: 27, hipIn: 37.875, inseamIn: 6.5, outseamIn: 15.5 }, { size: 'S', waistIn: 29, hipIn: 39.875, inseamIn: 6.75, outseamIn: 16 },
      { size: 'M', waistIn: 31, hipIn: 41.875, inseamIn: 7, outseamIn: 16.5 }, { size: 'L', waistIn: 33, hipIn: 43.875, inseamIn: 7.25, outseamIn: 17 },
      { size: 'XL', waistIn: 35, hipIn: 45.875, inseamIn: 7.5, outseamIn: 17.5 }, { size: 'XXL', waistIn: 38, hipIn: 48.875, inseamIn: 7.875, outseamIn: 18.25 }
    ],
    underwear: [ /* waist inches, rise cm */
      { size: 'XS', waistIn: 28, frontRise: 23.5 }, { size: 'S', waistIn: 30, frontRise: 24.5 },
      { size: 'M', waistIn: 32, frontRise: 25.5 }, { size: 'L', waistIn: 34, frontRise: 26.5 },
      { size: 'XL', waistIn: 37, frontRise: 27.5 }, { size: 'XXL', waistIn: 39, frontRise: 28.5 }
    ]
  };

  var FIT_INDEX = { slim: 0, regular: 1, relaxed: 2, oversized: 3 };

  /* Each garment: chart, body measurements to ask, and how a size is scored.
     ease = garment - body; target ease per fit [slim, regular, relaxed, oversized]. */
  var GARMENTS = {
    tshirt: { label: 'T-SHIRT', chart: 'tshirt', body: ['chest'], dims: [
      { name: 'CHEST', body: 'chest', g: function (r) { return r.chestHalf * 2; }, ease: [15, 19, 25, 33], tol: 5, w: 1 },
      { name: 'LENGTH', body: 'height', g: function (r) { return r.frontLength; }, target: function (h, f) { return h * 0.416 + [-0.5, 0, 0.8, 2][f]; }, tol: 2.2, w: 0.6 }
    ]},
    jersey: { label: 'JERSEY', chart: 'tshirt', body: ['chest'], dims: null },
    hoodie: { label: 'HOODIE', chart: 'hoodie', body: ['chest'], dims: [
      { name: 'CHEST', body: 'chest', g: function (r) { return r.chestHalf * 2; }, ease: [20, 26, 32, 40], tol: 6, w: 1 },
      { name: 'LENGTH', body: 'height', g: function (r) { return r.frontLength; }, target: function (h, f) { return h * 0.407 + [-0.5, 0, 0.8, 2][f]; }, tol: 2.4, w: 0.3 }
    ]},
    varsity: { label: 'VARSITY JACKET', chart: 'jacket', body: ['chest'], dims: [
      { name: 'CHEST', body: 'chest', g: function (r) { return r.chest; }, ease: [9, 14, 20, 28], tol: 5, w: 1 },
      { name: 'BACK LENGTH', body: 'height', g: function (r) { return r.backLength; }, target: function (h) { return h * 0.376; }, tol: 2, w: 0.3 },
      { name: 'SLEEVE', body: 'height', g: function (r) { return r.sleeveLength; }, target: function (h) { return h * 0.388; }, tol: 2, w: 0.3 }
    ]},
    bomber: { label: 'BOMBER JACKET', chart: 'jacket', body: ['chest'], dims: null },
    puffer: { label: 'PUFFER JACKET', chart: 'puffer', body: ['chest'], dims: [
      { name: 'CHEST', body: 'chest', g: function (r) { return r.chest; }, ease: [22, 28, 34, 42], tol: 6, w: 1 },
      { name: 'BACK LENGTH', body: 'height', g: function (r) { return r.backLength; }, target: function (h) { return h * 0.399; }, tol: 2.2, w: 0.25 },
      { name: 'SLEEVE', body: 'height', g: function (r) { return r.sleeveLength; }, target: function (h) { return h * 0.388; }, tol: 2, w: 0.3 }
    ]},
    shorts: { label: 'SHORTS', chart: 'shorts', body: ['waist', 'hip'], dims: [
      { name: 'WAIST', body: 'waist', g: function (r) { return r.waistIn * 2.54; }, ease: [-2.5, 0, 2.5, 5], tol: 3.8, w: 1 },
      { name: 'HIP', body: 'hip', g: function (r) { return r.hipIn * 2.54; }, ease: [6, 10, 15, 20], tol: 6, w: 0.7 },
      { name: 'LENGTH', body: 'height', g: function (r) { return r.outseamIn * 2.54; }, target: function (h, f) { return h * 0.238 + [-1, 0, 1, 2][f]; }, tol: 2.5, w: 0.2 }
    ]},
    underwear: { label: 'UNDERWEAR', chart: 'underwear', body: ['waist'], dims: [
      { name: 'WAIST', body: 'waist', g: function (r) { return r.waistIn * 2.54; }, ease: [-2.5, 0, 2.5, 5], tol: 3.8, w: 1 },
      { name: 'RISE', body: 'height', g: function (r) { return r.frontRise; }, target: function (h) { return h * 0.143; }, tol: 1.6, w: 0.25 }
    ]},
    cap: { label: 'CAP', chart: null, body: [], dims: [] }
  };
  /* Garment measurements shown on the result, straight from the size chart */
  var SPECS = {
    tshirt: [['CHEST (FLAT)', 'chestHalf', 'CM'], ['FRONT LENGTH', 'frontLength', 'CM'], ['SHOULDER', 'shoulder', 'CM']],
    hoodie: [['CHEST (FLAT)', 'chestHalf', 'CM'], ['FRONT LENGTH', 'frontLength', 'CM'], ['SHOULDER', 'shoulder', 'CM']],
    jacket: [['CHEST', 'chest', 'CM'], ['BACK LENGTH', 'backLength', 'CM'], ['SLEEVE', 'sleeveLength', 'CM']],
    puffer: [['CHEST', 'chest', 'CM'], ['HEM', 'hem', 'CM'], ['SLEEVE', 'sleeveLength', 'CM'], ['BACK LENGTH', 'backLength', 'CM']],
    shorts: [['WAIST', 'waistIn', 'IN'], ['HIP', 'hipIn', 'IN'], ['INSEAM', 'inseamIn', 'IN'], ['OUTSEAM', 'outseamIn', 'IN']],
    underwear: [['WAIST', 'waistIn', 'IN'], ['FRONT RISE', 'frontRise', 'CM']]
  };
  GARMENTS.jersey.dims = GARMENTS.tshirt.dims;
  GARMENTS.bomber.dims = GARMENTS.varsity.dims;

  /* Question definitions (values stored in metric) */
  var QUESTIONS = {
    height: { title: 'HEIGHT', copy: 'HOW TALL ARE YOU?', min: 140, max: 220, step: 1, units: ['cm', 'ftin'] },
    weight: { title: 'WEIGHT', copy: 'WHAT DO YOU WEIGH?', min: 35, max: 160, step: 1, units: ['kg', 'lb'] },
    chest: { title: 'CHEST', titleF: 'BUST', copy: 'FULLEST PART OF YOUR CHEST, TAPE LEVEL UNDER THE ARMS.', copyF: 'FULLEST PART OF YOUR BUST, TAPE LEVEL AROUND THE BACK.', min: 70, max: 150, step: 0.5, units: ['cm', 'in'] },
    waist: { title: 'WAIST', copy: 'WHERE YOU WEAR YOUR WAISTBAND, JUST ABOVE THE HIPS.', min: 55, max: 140, step: 0.5, units: ['cm', 'in'] },
    hip: { title: 'HIP', copy: 'WIDEST PART OF YOUR HIPS AND SEAT.', min: 70, max: 150, step: 0.5, units: ['cm', 'in'] }
  };

  /* Body measurement estimates from height (cm) + weight (kg) */
  function estimate(key, s) {
    var female = s.gender === 'female';
    var ratio = (s.weight / s.height) / (female ? 64 / 165 : 78 / 178);
    var v = null;
    if (key === 'chest') v = (female ? 92 : 100) * Math.pow(ratio, 0.55);
    if (key === 'waist') v = (female ? 76 : 86) * Math.pow(ratio, 0.95);
    if (key === 'hip') v = (female ? 100 : 98) * Math.pow(ratio, 0.55);
    return v == null ? null : round1(clamp(v, QUESTIONS[key].min, QUESTIONS[key].max));
  }

  function round1(n) { return Math.round(n * 2) / 2; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function fmt(n) { var r = Math.round(n * 10) / 10; return (Math.abs(r - Math.round(r)) < 0.05 ? Math.round(r) : r.toFixed(1)) + ''; }

  /* ------------------------------------------------------------------ *
   * Recommendation engine
   * ------------------------------------------------------------------ */
  function recommend(s, allowedSizes) {
    var g = GARMENTS[s.product];
    if (!g || !g.chart) return { size: 'ONE SIZE', conf: 100, oneSize: true };
    var rows = CHARTS[g.chart];
    if (allowedSizes && allowedSizes.length) {
      var allowed = allowedSizes.map(function (x) { return String(x).trim().toUpperCase(); });
      var filtered = rows.filter(function (r) { return allowed.indexOf(r.size) !== -1; });
      if (filtered.length) rows = filtered;
    }
    var fi = FIT_INDEX[s.fit] != null ? FIT_INDEX[s.fit] : 1;

    var scored = rows.map(function (row) {
      var total = 0, wsum = 0, parts = [];
      g.dims.forEach(function (d) {
        var gv = d.g(row), want, bodyVal = null;
        if (d.body === 'height') { want = d.target(s.height, fi); }
        else { bodyVal = s[d.body]; want = bodyVal + d.ease[fi]; }
        var z = (gv - want) / d.tol;
        // too short / too tight hurts more than a little extra room
        var pen = z < 0 ? (d.body === 'height' ? 1.5 : 1.2) : 1;
        total += d.w * (z * pen) * (z * pen); wsum += d.w;
        parts.push({ dim: d, z: z, garment: gv, body: bodyVal, ease: bodyVal != null ? gv - bodyVal : null });
      });
      return { row: row, score: total / wsum, parts: parts };
    });

    var sorted = scored.slice().sort(function (a, b) { return a.score - b.score; });
    var best = sorted[0], second = sorted[1];
    var err = Math.sqrt(best.score);
    var conf = 100 * (0.55 + 0.45 * Math.exp(-err * err * 0.7));
    var alt = null;
    if (second) {
      var margin = (second.score - best.score) / (second.score + best.score + 0.05);
      conf -= (1 - Math.min(1, margin * 2.5)) * 10;
      var bi = rows.indexOf(best.row);
      var nb = [scored[bi - 1], scored[bi + 1]].filter(Boolean).sort(function (a, b) { return a.score - b.score; })[0];
      var nm = nb ? (nb.score - best.score) / (nb.score + best.score + 0.05) : 1;
      if (nb && nm < 0.35) alt = { row: nb.row, roomier: rows.indexOf(nb.row) > bi };
    }
    var primary = best.parts[0];
    var edge = null;
    var idx = rows.indexOf(best.row);
    if (primary.z < -1.6 && idx === rows.length - 1) edge = 'small';
    if (primary.z > 1.6 && idx === 0) edge = 'large';
    if (edge) conf = Math.min(conf, 62);
    if (alt && (edge || (primary.z > 1 && alt.roomier) || (primary.z < -1 && !alt.roomier))) alt = null;

    return {
      size: best.row.size, conf: Math.round(clamp(conf, 60, 98)),
      parts: best.parts, alt: alt, edge: edge, garment: g, row: best.row, rows: rows
    };
  }

  /* ------------------------------------------------------------------ *
   * Helpers
   * ------------------------------------------------------------------ */
  function detectGarment(p) {
    if (!p) return null;
    var hay = [p.type, p.title, p.handle].concat(p.tags || []).join(' ').toLowerCase();
    var map = [
      [/\b(cap|hat|headwear|beanie)\b/, 'cap'], [/hood/, 'hoodie'], [/puffer|down jacket/, 'puffer'],
      [/varsity|letterman/, 'varsity'], [/bomber/, 'bomber'], [/jersey/, 'jersey'],
      [/boxer|brief|trunk|underwear/, 'underwear'], [/\bshorts?\b/, 'shorts'],
      [/t-?shirt|\btee\b|tshirt/, 'tshirt']
    ];
    for (var i = 0; i < map.length; i++) if (map[i][0].test(hay)) return map[i][1];
    return null;
  }

  var mvPromise = null;
  function ensureModelViewer() {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (mvPromise) return mvPromise;
    mvPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
      s.onload = function () { customElements.whenDefined('model-viewer').then(resolve); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return mvPromise;
  }


  /* ------------------------------------------------------------------ *
   * Component
   * ------------------------------------------------------------------ */
  var DEFAULTS = { male: { height: 178, weight: 72 }, female: { height: 165, weight: 60 } };

  function FitRecon(root) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-frx2-config]').textContent); } catch (e) {}
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var desktopMQ = window.matchMedia('(min-width: 900px)');
    var customer = cfg.customer || null;
    var storeKey = customer ? STORE_PREFIX + customer.id : null;
    var detected = detectGarment(cfg.product);
    var productSizes = (cfg.product && cfg.product.sizes) || [];

    function loadSaved() { if (!storeKey) return null; try { return JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch (e) { return null; } }
    function writeSaved() {
      if (!storeKey) return false;
      try {
        localStorage.setItem(storeKey, JSON.stringify({
          gender: s.gender, height: s.height, weight: s.weight, chest: s.chest, waist: s.waist, hip: s.hip,
          touched: s.touched, units: s.units, fit: s.fit, t: Date.now()
        }));
        return true;
      } catch (e) { return false; }
    }
    function forgetSaved() { if (storeKey) try { localStorage.removeItem(storeKey); } catch (e) {} }
    function sameAsSaved() {
      var sv = loadSaved();
      if (!sv) return false;
      return ['gender', 'height', 'weight', 'chest', 'waist', 'hip', 'fit'].every(function (k) { return sv[k] === s[k]; });
    }

    var s = {};
    function fresh(gender) {
      var g = gender || 'male';
      s.gender = g; s.height = DEFAULTS[g].height; s.weight = DEFAULTS[g].weight;
      s.touched = {}; s.fit = 'regular'; s.product = s.product || null;
      s.units = s.units || { height: 'cm', weight: 'kg', body: 'cm' };
      syncEstimates();
    }
    function syncEstimates() {
      ['chest', 'waist', 'hip'].forEach(function (k) { if (!s.touched[k] || s[k] == null) s[k] = estimate(k, s); });
    }
    fresh('male');

    /* ---------- navigation ---------- */
    var history = [];
    var current = 'welcome';
    var mode = 'new';          // 'new' = enter details, 'saved' = reuse saved profile
    var usedSavedView = false;
    var queue = [];
    var qi = 0;

    function show(name, opts) {
      opts = opts || {};
      if (!opts.back && current && current !== name && current !== 'scan') history.push({ view: current, qi: qi });
      $$('.frx2-view').forEach(function (v) {
        var on = v.getAttribute('data-view') === name;
        v.classList.toggle('is-active', on);
        v.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in v) v.inert = !on;
      });
      current = name;
      root.setAttribute('data-step', name);
      $('[data-frx-top]').hidden = name === 'welcome';
      updateProgress();
      if (opts.focus !== false) {
        var h = $('.frx2-view.is-active .frx2-h');
        if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
        keepInView();
      }
    }

    // On phones keep the active step in view when it changes
    function headerOffset() {
      var h = document.querySelector('sticky-header, .header-wrapper, header[role="banner"], .shopify-section-group-header-group header, header');
      if (!h) return 0;
      var cs = getComputedStyle(h.closest('.shopify-section') || h);
      var pos = cs.position === 'sticky' || cs.position === 'fixed' ? cs.position : getComputedStyle(h).position;
      var b = h.getBoundingClientRect().bottom;
      return (pos === 'sticky' || pos === 'fixed') && b > 0 && b < 160 ? Math.round(b) : 0;
    }
    function measureHeader() { root.style.setProperty('--frx-sticky-top', headerOffset() + 'px'); }
    function keepInView() {
      if (desktopMQ.matches) return;
      measureHeader();
      var panel = $('[data-frx-panel]');
      var top = panel.getBoundingClientRect().top, off = headerOffset() + 8;
      if (top < off - 1 || top > window.innerHeight * 0.45) {
        window.scrollTo({ top: window.pageYOffset + top - off, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function stepList() {
      var list = [];
      if (usedSavedView) list.push('saved');
      if (mode === 'new') list.push('gender');
      list.push('garment');
      var p = s.product || detected, g = GARMENTS[p];
      var qn = queue.length || (g ? (g.chart ? 2 + g.body.length : 0) : 3);
      if (mode === 'new') for (var i = 0; i < qn; i++) list.push('q' + i);
      if (p !== 'cap') list.push('fit');
      list.push('result');
      return list;
    }
    function updateProgress() {
      var list = stepList();
      var key = current === 'measure' ? 'q' + qi : current === 'scan' ? 'result' : current;
      var i = list.indexOf(key);
      var pct = current === 'result' ? 100 : i < 0 ? 0 : ((i + 1) / list.length) * 100;
      $('[data-frx-progress]').style.width = pct + '%';
      $('[data-frx-stepcount]').textContent = current === 'result' ? 'REPORT' : (i >= 0 ? 'STEP ' + (i + 1) + ' / ' + list.length : '');
      var k = $('.frx2-view[data-view="' + current + '"] [data-kicker]');
      if (k) {
        k.textContent = current === 'gender' ? 'ABOUT YOU' : current === 'garment' ? 'THE GARMENT'
          : current === 'measure' ? 'MEASUREMENT ' + (qi + 1) + ' OF ' + queue.length : current === 'fit' ? 'FIT PREFERENCE' : '';
      }
    }

    function back() {
      var prev = history.pop();
      if (!prev) return goHome();
      if (prev.view === 'measure') { qi = prev.qi; renderQuestion(); }
      if (prev.view === 'garment') markGarment();
      show(prev.view, { back: true });
    }

    function goHome() {
      history = [];
      usedSavedView = false;
      $('[data-frx-badge]').hidden = true;
      show('welcome', { back: true });
    }

    /* ---------- flow ---------- */
    function start() {
      history = [];
      usedSavedView = false;
      var sv = loadSaved();
      if (customer && sv) { usedSavedView = true; renderSaved(sv); return show('saved'); }
      mode = 'new';
      show('gender');
    }

    function useSaved() {
      var sv = loadSaved();
      if (!sv) return startNew();
      ['gender', 'height', 'weight', 'chest', 'waist', 'hip', 'fit'].forEach(function (k) { if (sv[k] != null) s[k] = sv[k]; });
      s.units = sv.units || s.units;
      s.touched = sv.touched || {};
      s.touched.height = s.touched.weight = true;
      mode = 'saved';
      setGender(s.gender, true);
      markGarment();
      show('garment');
    }
    function startNew() {
      fresh(s.gender);
      mode = 'new';
      show('gender');
    }

    function chooseGender(gd) {
      if (gd !== s.gender && !s.touched.height) fresh(gd);
      setGender(gd);
      markGarment();
      show('garment');
    }
    function markGarment() {
      var sel = s.product || detected;
      $$('.frx2-pcard').forEach(function (b) {
        var p = b.getAttribute('data-product');
        b.classList.toggle('is-active', p === sel);
        b.classList.toggle('is-this', p === detected);
      });
    }
    function chooseGarment(p) {
      s.product = p;
      markGarment();
      buildQueue();
      if (p === 'cap') return finish();
      if (mode === 'saved') return showFit();
      renderQuestion();
      show('measure');
    }
    function buildQueue() {
      var g = GARMENTS[s.product];
      queue = g && g.chart ? ['height', 'weight'].concat(g.body) : [];
      qi = 0;
    }
    function nextQuestion() {
      if (qi < queue.length - 1) {
        history.push({ view: 'measure', qi: qi });
        qi++;
        renderQuestion();
        swapAnim();
        updateProgress();
        keepInView();
        return;
      }
      showFit();
    }
    function showFit() {
      $$('.frx2-fcard').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fit') === s.fit ? 'true' : 'false'); });
      show('fit');
    }
    function swapAnim() {
      var v = $('[data-view="measure"]');
      if (reduceMotion || !v.animate) return;
      v.animate([{ opacity: 0, transform: 'translateX(16px)' }, { opacity: 1, transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    function finish() {
      show('scan');
      setTimeout(function () { renderResult(); show('result'); }, reduceMotion ? 0 : 950);
    }

    /* ---------- saved profile card ---------- */
    function renderSaved(sv) {
      var bu = sv.units && sv.units.body === 'in' ? 'in' : 'cm';
      var c = function (v) { return bu === 'in' ? fmt(v / 2.54) + ' IN' : fmt(v) + ' CM'; };
      var rows = [
        [sv.gender === 'female' ? 'female' : 'male', 'PROFILE', sv.gender === 'female' ? 'FEMALE' : 'MALE'],
        ['height', 'HEIGHT', fmt(sv.height) + ' CM'],
        ['weight', 'WEIGHT', fmt(sv.weight) + ' KG'],
        ['chest', sv.gender === 'female' ? 'BUST' : 'CHEST', c(sv.chest)],
        ['waist', 'WAIST', c(sv.waist)],
        ['tee', 'FIT', String(sv.fit || 'regular').toUpperCase()]
      ];
      $('[data-saved-summary]').innerHTML = rows.map(function (r) {
        return '<div class="frx2-profile__item"><svg class="frx2-i"><use href="#frx-i-' + r[0] + '"/></svg><span>' + r[1] + '</span><b>' + r[2] + '</b></div>';
      }).join('');
    }

    /* ---------- measurement question ---------- */
    var range = $('[data-q-range]');
    var ruler = $('[data-q-ruler]');
    function unitFor(key) { return key === 'height' ? s.units.height : key === 'weight' ? s.units.weight : s.units.body; }
    function toDisplay(key, v) { var u = unitFor(key); return u === 'ftin' || u === 'in' ? v / 2.54 : u === 'lb' ? v * 2.20462 : v; }
    function fromDisplay(key, d) { var u = unitFor(key); return u === 'ftin' || u === 'in' ? d * 2.54 : u === 'lb' ? d / 2.20462 : d; }
    function displayText(key, d) {
      if (unitFor(key) === 'ftin') { var t = Math.round(d); return Math.floor(t / 12) + '′' + (t % 12) + '″'; }
      return fmt(d);
    }
    function unitLabel(key) { var u = unitFor(key); return u === 'ftin' ? '' : u.toUpperCase(); }
    function displayStep(key) { var u = unitFor(key); return u === 'ftin' || u === 'lb' ? 1 : u === 'in' ? 0.25 : QUESTIONS[key].step; }

    function renderQuestion() {
      var key = queue[qi], q = QUESTIONS[key];
      if (!q) return;
      var female = s.gender === 'female';
      $('[data-q-title]').textContent = female && q.titleF ? q.titleF : q.title;
      $('[data-q-icon]').innerHTML = icon(key);
      $('[data-q-copy]').textContent = female && q.copyF ? q.copyF : q.copy;

      var unitsBox = $('[data-q-units]');
      unitsBox.innerHTML = '';
      q.units.forEach(function (u) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = u === 'ftin' ? 'FT / IN' : u.toUpperCase();
        b.setAttribute('aria-pressed', unitFor(key) === u ? 'true' : 'false');
        b.addEventListener('click', function () {
          if (key === 'height') s.units.height = u; else if (key === 'weight') s.units.weight = u; else s.units.body = u;
          renderQuestion(); paintVisual();
        });
        unitsBox.appendChild(b);
      });

      var st = displayStep(key);
      var lo = Math.floor(toDisplay(key, q.min) / st) * st, hi = Math.ceil(toDisplay(key, q.max) / st) * st;
      range.min = lo; range.max = hi; range.step = st;
      range.value = toDisplay(key, s[key]);
      range.setAttribute('aria-label', q.title + ' in ' + (unitLabel(key) || 'feet and inches'));

      var labels = $('[data-q-labels]');
      labels.innerHTML = '';
      var span = hi - lo, nice = [1, 2, 5, 10, 12, 20, 25, 50], stepL = 50;
      for (var i = 0; i < nice.length; i++) if (span / nice[i] <= 6) { stepL = nice[i]; break; }
      if (unitFor(key) === 'ftin') stepL = 6;
      for (var v = Math.ceil(lo / stepL) * stepL; v <= hi + 1e-6; v += stepL) {
        var sp = document.createElement('span');
        sp.style.setProperty('--x', ((v - lo) / span).toFixed(4));
        sp.textContent = unitFor(key) === 'ftin' ? (Math.floor(v / 12) + '′' + (v % 12 ? (v % 12) + '″' : '')) : fmt(v);
        labels.appendChild(sp);
      }
      ruler.style.setProperty('--ticks', Math.max(10, Math.min(80, Math.round(span / (unitFor(key) === 'ftin' ? 1 : stepL / 5)))));
      $('[data-q-next] span').textContent = qi === queue.length - 1 ? 'CONTINUE' : 'NEXT';
      paintQuestion();
    }

    function paintQuestion() {
      var key = queue[qi];
      if (!key) return;
      var d = parseFloat(range.value), lo = parseFloat(range.min), hi = parseFloat(range.max);
      ruler.style.setProperty('--p', ((d - lo) / (hi - lo)).toFixed(4));
      $('[data-q-value]').textContent = displayText(key, d);
      $('[data-q-unit]').textContent = unitLabel(key);
      var hint = $('[data-q-hint]');
      if (key === 'chest' || key === 'waist' || key === 'hip') {
        hint.hidden = false;
        hint.innerHTML = s.touched[key]
          ? '<span>YOUR OWN MEASUREMENT</span><button type="button" data-q-estimate>USE ESTIMATE</button>'
          : '<span class="frx2-pill">ESTIMATED</span><span>FROM YOUR HEIGHT &amp; WEIGHT — ADJUST IF YOU KNOW IT</span>';
      } else hint.hidden = true;
    }

    var raf = 0;
    function onRangeInput() {
      var key = queue[qi];
      s[key] = Math.round(fromDisplay(key, parseFloat(range.value)) * 10) / 10;
      s.touched[key] = true;
      if (key === 'height' || key === 'weight') syncEstimates();
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; paintQuestion(); paintVisual(); });
    }
    range.addEventListener('input', onRangeInput);
    range.addEventListener('pointerdown', function () { ruler.classList.add('is-dragging'); });
    window.addEventListener('pointerup', function () { ruler.classList.remove('is-dragging'); });
    range.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); nextQuestion(); } });

    $$('[data-q-step]').forEach(function (b) {
      var dir = parseFloat(b.getAttribute('data-q-step')), hold = null, wait = null;
      function bump() {
        var st = parseFloat(range.step) || 1;
        range.value = clamp(parseFloat(range.value) + dir * st, parseFloat(range.min), parseFloat(range.max));
        onRangeInput();
      }
      function stop() { clearTimeout(wait); clearInterval(hold); }
      b.addEventListener('click', function (e) { if (e.detail === 0 || !b.__held) bump(); b.__held = false; });
      b.addEventListener('pointerdown', function () {
        stop();
        wait = setTimeout(function () { b.__held = true; hold = setInterval(bump, 70); }, 380);
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { b.addEventListener(ev, stop); });
    });

    /* ---------- result ---------- */
    var DIM_ICON = { 'CHEST': 'chest', 'LENGTH': 'length', 'BACK LENGTH': 'length', 'SLEEVE': 'ruler', 'WAIST': 'waist', 'HIP': 'hip', 'RISE': 'ruler' };

    function renderResult() {
      var r = recommend(s, detected && s.product === detected ? productSizes : null);
      var g = GARMENTS[s.product];
      var female = s.gender === 'female', bu = s.units.body === 'in';
      $('[data-r-garment]').textContent = g ? g.label : '';
      $('[data-r-size]').textContent = r.oneSize ? 'OS' : r.size;
      $('[data-r-size2]').textContent = r.size;
      $('[data-r-ring]').classList.toggle('is-long', String(r.size).length > 2);

      // confidence ring + label
      var C = 326.7, bar = $('[data-r-ring-bar]');
      bar.style.strokeDashoffset = C;
      requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.strokeDashoffset = (C * (1 - r.conf / 100)).toFixed(1); }); });
      countUp($('[data-r-conf]'), r.conf);
      var match = r.conf >= 90 ? 'EXCELLENT MATCH' : r.conf >= 80 ? 'GREAT MATCH' : r.conf >= 70 ? 'GOOD MATCH' : 'CLOSEST AVAILABLE';
      var m = $('[data-r-match]');
      m.textContent = match;
      m.className = 'frx2-match' + (r.conf >= 80 ? ' is-high' : r.conf >= 70 ? '' : ' is-low');

      // summary
      var summary;
      if (r.oneSize) summary = 'ONE SIZE WITH AN ADJUSTABLE STRAP. IT WILL FIT.';
      else if (r.edge === 'small') summary = r.size + ' IS OUR LARGEST SIZE AND MAY FEEL SNUG ON YOU.';
      else if (r.edge === 'large') summary = r.size + ' IS OUR SMALLEST SIZE AND MAY FEEL LOOSE ON YOU.';
      else summary = 'SIZE ' + r.size + ' GIVES YOU A ' + s.fit.toUpperCase() + ' FIT IN OUR ' + g.label + '.';
      $('[data-r-summary]').textContent = summary;

      // size strip
      var strip = $('[data-r-sizes]');
      strip.hidden = !!r.oneSize;
      strip.innerHTML = r.oneSize ? '' : r.rows.map(function (row) {
        var cls = row.size === r.size ? ' is-pick' : (r.alt && row.size === r.alt.row.size ? ' is-alt' : '');
        var tag = row.size === r.size ? '<i>YOURS</i>' : (r.alt && row.size === r.alt.row.size ? '<i>ALT</i>' : '');
        return '<span class="frx2-size' + cls + '">' + row.size + tag + '</span>';
      }).join('');

      // fit meters
      var meters = $('[data-r-meters]');
      meters.innerHTML = '';
      meters.closest('.frx2-block').hidden = !!r.oneSize;
      if (!r.oneSize) r.parts.forEach(function (p) {
        var z = clamp(p.z, -2, 2), len = p.dim.body === 'height';
        var word = Math.abs(p.z) < 0.6 ? 'SPOT ON' : p.z < 0 ? (len ? 'A LITTLE SHORT' : 'A LITTLE SNUG') : (len ? 'A LITTLE LONG' : 'A LITTLE LOOSE');
        if (Math.abs(p.z) >= 1.4) word = word.replace('A LITTLE ', '');
        var extra = p.ease != null ? '<small>' + (p.ease >= 0 ? '+' : '') + fmt(p.ease) + ' CM ROOM</small>' : '';
        var name = p.dim.name === 'CHEST' && female ? 'BUST' : p.dim.name;
        var row = document.createElement('div');
        row.className = 'frx2-meter' + (Math.abs(p.z) < 0.6 ? ' is-good' : Math.abs(p.z) >= 1.4 ? ' is-off' : '');
        row.innerHTML = '<span class="frx2-meter__ic">' + icon(DIM_ICON[p.dim.name] || 'ruler') + '</span>' +
          '<div class="frx2-meter__body"><div class="frx2-meter__head"><b>' + name + '</b><span>' + word + extra + '</span></div>' +
          '<div class="frx2-meter__track"><i style="--m:' + ((z + 2) / 4).toFixed(3) + '"></i></div>' +
          '<div class="frx2-meter__ends"><span>' + (len ? 'SHORT' : 'SNUG') + '</span><span>IDEAL</span><span>' + (len ? 'LONG' : 'LOOSE') + '</span></div></div>';
        meters.appendChild(row);
      });

      var alt = $('[data-r-alt]');
      alt.hidden = !r.alt;
      if (r.alt) alt.innerHTML = icon('target') + '<span>BETWEEN SIZES? <b>' + r.alt.row.size + '</b> ' + (r.alt.roomier ? 'GIVES A ROOMIER, LONGER FIT.' : 'GIVES A CLOSER, SHORTER FIT.') + '</span>';

      // garment measurements for the recommended size (straight from the chart)
      var specs = $('[data-r-specs]'), spec = g && g.chart ? SPECS[g.chart] : null;
      specs.closest('.frx2-block').hidden = !spec;
      specs.innerHTML = spec ? spec.filter(function (x) { return r.row[x[1]] != null; }).map(function (x) {
        return '<div class="frx2-spec"><span>' + x[0] + '</span><b>' + fmt(r.row[x[1]]) + '<small>' + x[2] + '</small></b></div>';
      }).join('') : '';

      // profile chips
      var cv = function (v) { return bu ? fmt(v / 2.54) + ' IN' : fmt(v) + ' CM'; };
      var chips = [[female ? 'female' : 'male', female ? 'FEMALE' : 'MALE'], ['height', fmt(s.height) + ' CM'], ['weight', fmt(s.weight) + ' KG']];
      if (g && g.body.indexOf('chest') !== -1) chips.push(['chest', cv(s.chest)]);
      if (g && g.body.indexOf('waist') !== -1) chips.push(['waist', cv(s.waist)]);
      if (g && g.body.indexOf('hip') !== -1) chips.push(['hip', cv(s.hip)]);
      if (!r.oneSize) chips.push(['tee', s.fit.toUpperCase()]);
      $('[data-r-chips]').innerHTML = chips.map(function (c) { return '<span>' + icon(c[0]) + c[1] + '</span>'; }).join('');

      // select the size on this product page
      var sel = $('[data-r-select]');
      var picker = !r.oneSize && detected === s.product ? findSizeInput(r.size) : null;
      sel.hidden = !picker;
      if (picker) {
        var plabel = picker.id && document.querySelector('label[for="' + CSS.escape(picker.id) + '"]');
        var soldOut = (plabel && /sold out/i.test(plabel.textContent)) || picker.disabled;
        sel.innerHTML = '<span>SELECT SIZE ' + r.size + (soldOut ? ' · SOLD OUT IN THIS COLOUR' : '') + '</span>' + icon('arrow');
      }
      sel.onclick = function () {
        var input = findSizeInput(r.size);
        if (!input) return;
        var label = input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        (label || input).click();
        if (input.tagName === 'SELECT') { input.value = r.size; input.dispatchEvent(new Event('change', { bubbles: true })); }
        var target = (label || input).closest('variant-picker, .variant-picker, product-form, form') || label || input;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        (label || input).classList.add('frx2-flash');
        setTimeout(function () { (label || input).classList.remove('frx2-flash'); }, 1600);
        var ok = !(input.disabled || (input.type === 'radio' && !input.checked));
        sel.innerHTML = '<span>' + (ok ? 'SIZE ' + r.size + ' SELECTED' : r.size + ' IS SOLD OUT · GET NOTIFIED BELOW') + '</span>' + icon(ok ? 'check' : 'arrow');
      };

      renderSaveButton();
      $('[data-frx-badge-size]').textContent = r.oneSize ? 'OS' : r.size;
      $('[data-frx-badge]').hidden = false;
    }

    function countUp(el, to) {
      if (reduceMotion) { el.textContent = to + '%'; return; }
      var t0 = null;
      (function tick(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(to * e) + '%';
        if (k < 1) requestAnimationFrame(tick);
      })(performance.now());
    }

    function renderSaveButton() {
      var save = $('[data-r-save]'), login = $('[data-r-login]');
      if (customer) {
        login.hidden = true;
        save.hidden = false;
        var done = sameAsSaved();
        save.classList.toggle('is-done', done);
        save.innerHTML = icon(done ? 'check' : 'save') + '<span>' + (done ? 'DETAILS SAVED TO YOUR PROFILE' : 'SAVE MY DETAILS FOR NEXT TIME') + '</span>';
      } else {
        save.hidden = true;
        login.hidden = false;
        login.href = cfg.loginUrl || '/account/login';
      }
    }

    function icon(name) { return '<svg class="frx2-i"><use href="#frx-i-' + name + '"/></svg>'; }

    function findSizeInput(size) {
      var want = String(size).toUpperCase();
      var radios = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"], form[action*="/cart/add"] input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        var label = r.id ? document.querySelector('label[for="' + CSS.escape(r.id) + '"]') : null;
        var text = ((label && label.textContent) || '').replace(/\s+/g, ' ').trim().toUpperCase();
        if (text === want || text.split(' ')[0] === want || String(r.value).trim().toUpperCase() === want) return r;
      }
      var selects = document.querySelectorAll('variant-picker select, form[action*="/cart/add"] select');
      for (var j = 0; j < selects.length; j++) {
        for (var k = 0; k < selects[j].options.length; k++) if (selects[j].options[k].value.trim().toUpperCase() === want) return selects[j];
      }
      return null;
    }

    /* ---------- visual (desktop & tablet only) ---------- */
    var bodyEl = $('[data-frx-body]');
    var markerEl = $('[data-frx-marker]');
    function paintVisual() {
      if (!desktopMQ.matches) return;
      var female = s.gender === 'female';
      var setOut = function (k, v, unit) {
        var b = root.querySelector('[data-out="' + k + '"]'), u = root.querySelector('[data-out-unit="' + k + '"]');
        if (b) b.textContent = v;
        if (u) u.textContent = unit;
      };
      var bu = s.units.body === 'in' ? 'IN' : 'CM', conv = s.units.body === 'in' ? 1 / 2.54 : 1;
      setOut('height', s.units.height === 'ftin' ? displayText('height', s.height / 2.54) : fmt(s.height), s.units.height === 'ftin' ? '' : 'CM');
      setOut('weight', s.units.weight === 'lb' ? fmt(s.weight * 2.20462) : fmt(s.weight), s.units.weight === 'lb' ? 'LB' : 'KG');
      setOut('chest', fmt(s.chest * conv), bu);
      setOut('waist', fmt(s.waist * conv), bu);
      setOut('hip', fmt(s.hip * conv), bu);
      var cl = root.querySelector('[data-out-label="chest"]');
      if (cl) cl.textContent = female ? 'BUST' : 'CHEST';
      var hy = clamp(s.height / 220, 0, 1);
      markerEl.style.setProperty('--y', (1 - hy).toFixed(4));
      markerEl.textContent = fmt(s.height) + ' CM';
      var ratio = (s.weight / s.height) / (female ? 64 / 165 : 78 / 178);
      bodyEl.style.setProperty('--sy', hy.toFixed(4));
      bodyEl.style.setProperty('--sx', clamp(Math.pow(ratio, 0.6) * (female ? 0.96 : 1), 0.82, 1.28).toFixed(4));
    }

    var modelEl = $('[data-frx-model]');
    var loaderEl = $('[data-frx-loader]');
    var viewers = {};
    var near = false;
    function setLoader(p) {
      loaderEl.hidden = p == null;
      if (p == null) return;
      $('[data-frx-loader-text]').textContent = Math.round(p * 100) + '%';
      $('[data-frx-loader-bar]').style.strokeDashoffset = (119.4 * (1 - p)).toFixed(1);
    }
    function showModel() {
      if (!desktopMQ.matches || !near) return;
      paintVisual();
      var gd = s.gender;
      Object.keys(viewers).forEach(function (k) {
        var on = k === gd && viewers[k].__loaded;
        viewers[k].classList.toggle('is-on', on);
        viewers[k].inert = !on;   // a hidden viewer must never sit on top and swallow drags
      });
      if (viewers[gd]) { setLoader(viewers[gd].__loaded ? null : (viewers[gd].__p || 0)); return; }
      setLoader(0);
      ensureModelViewer().then(function () {
        var mv = document.createElement('model-viewer');
        mv.setAttribute('src', cfg.models[gd]);
        mv.setAttribute('alt', (gd === 'female' ? 'Female' : 'Male') + ' 3D body model');
        ['camera-controls', 'disable-zoom', 'disable-pan'].forEach(function (a) { mv.setAttribute(a, ''); });
        mv.setAttribute('interaction-prompt', 'none');
        mv.setAttribute('camera-orbit', '0deg 88deg auto');
        mv.setAttribute('shadow-intensity', '0.6');
        mv.setAttribute('environment-image', 'neutral');
        mv.setAttribute('loading', 'eager');
        mv.addEventListener('progress', function (e) {
          if (mv.__loaded) return;
          mv.__p = e.detail.totalProgress;
          if (s.gender === gd) setLoader(Math.min(0.99, mv.__p));
        });
        mv.addEventListener('load', function () {
          mv.__loaded = true;
          mv.inert = s.gender !== gd;
          if (s.gender === gd) { setLoader(null); mv.classList.add('is-on'); }
        });
        mv.addEventListener('error', function () { setLoader(null); });
        mv.inert = true;
        viewers[gd] = mv;
        modelEl.appendChild(mv);
      }).catch(function () { setLoader(null); });
    }

    function setGender(gd, keepValues) {
      s.gender = gd === 'female' ? 'female' : 'male';
      if (!keepValues) {
        if (!s.touched.height) s.height = DEFAULTS[s.gender].height;
        if (!s.touched.weight) s.weight = DEFAULTS[s.gender].weight;
      }
      syncEstimates();
      $$('[data-frx-action="male"],[data-frx-action="female"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-frx-action') === s.gender ? 'true' : 'false');
      });
      $$('.frx2-gcard').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-gender') === s.gender); });
      root.setAttribute('data-gender', s.gender);
      showModel();
      paintVisual();
    }

    var angle = 0;
    function rotate() {
      angle += 90;
      var mv = viewers[s.gender];
      if (mv) mv.setAttribute('camera-orbit', angle + 'deg 88deg auto');
    }
    function resetAll() {
      angle = 0;
      Object.keys(viewers).forEach(function (k) { viewers[k].setAttribute('camera-orbit', '0deg 88deg auto'); });
      s.product = null;
      fresh('male');
      setGender('male');
      goHome();
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      var hit = function (sel) { return t.closest(sel); };
      var el;
      if (hit('[data-frx-start]')) return start();
      if (hit('[data-saved-use]')) return useSaved();
      if (hit('[data-saved-new]')) return startNew();
      if (hit('[data-saved-forget]')) { forgetSaved(); usedSavedView = false; history = []; return startNew(); }
      if ((el = hit('.frx2-gcard'))) return chooseGender(el.getAttribute('data-gender'));
      if ((el = hit('.frx2-pcard'))) return chooseGarment(el.getAttribute('data-product'));
      if (hit('[data-q-next]')) return nextQuestion();
      if (hit('[data-q-estimate]')) {
        var key = queue[qi];
        s.touched[key] = false; s[key] = estimate(key, s);
        range.value = toDisplay(key, s[key]);
        paintQuestion(); paintVisual();
        return;
      }
      if ((el = hit('.frx2-fcard'))) {
        s.fit = el.getAttribute('data-fit');
        $$('.frx2-fcard').forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
        return finish();
      }
      if (hit('[data-frx-back]')) return back();
      if (hit('[data-frx-home]')) return goHome();
      if (hit('[data-r-save]')) {
        if (writeSaved()) renderSaveButton();
        return;
      }
      if (hit('[data-r-edit]')) {
        mode = 'new';
        if (s.product === 'cap') { history = []; return show('garment'); }
        buildQueue(); renderQuestion();
        history = [{ view: 'garment', qi: 0 }];
        return show('measure');
      }
      if (hit('[data-r-restart]')) return goHome();
      if ((el = hit('[data-frx-action]'))) {
        var a = el.getAttribute('data-frx-action');
        if (a === 'male' || a === 'female') {
          if (a !== s.gender && !s.touched.height) { s.gender = a; fresh(a); }
          setGender(a);
          if (current === 'result') renderResult();
          if (current === 'measure') renderQuestion();
        } else if (a === 'rotate') rotate();
        else if (a === 'reset') resetAll();
      }
    });

    /* ---------- boot ---------- */
    setGender('male');
    show('welcome', { back: true, focus: false });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !near) { near = true; showModel(); }
      }, { rootMargin: '400px 0px' }).observe(root);
    } else { near = true; showModel(); }
    desktopMQ.addEventListener('change', function () { showModel(); measureHeader(); });
    measureHeader();
    window.addEventListener('resize', measureHeader, { passive: true });

    root.__fitRecon = { state: s, recommend: function () { return recommend(s, productSizes); } };
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-frx2]');
    for (var i = 0; i < nodes.length; i++) if (!nodes[i].__frx) { nodes[i].__frx = true; FitRecon(nodes[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  window.BGFitRecon = { recommend: recommend, estimate: estimate, GARMENTS: GARMENTS, CHARTS: CHARTS };
})();
